import { render } from "./index.vue?vue&type=template&id=cb2bde1a&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=cb2bde1a&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=cb2bde1a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb2bde1a"]])

export default __exports__